import React from 'react';
import PropTypes from 'prop-types';

import './licenseForm.scss';
import LicenseFormContainer from '../../../containers/LicenseFormContainer';
import LicenseSubscriptionFormContainer from '../../../containers/LicenseSubscriptionFormContainer';

class LicenseOuterFormComponent extends React.Component {
    render() {
        const { page, isInvalid, updateInvalid } = this.props;

        updateInvalid(isInvalid);

        return <div className='license container'>
            {(page === 1) && <LicenseFormContainer {...this.props} />}
            {(page === 2) && <LicenseSubscriptionFormContainer {...this.props} />}
        </div>;
    }
}

LicenseOuterFormComponent.propTypes = {
    page: PropTypes.number.isRequired,
    isInvalid: PropTypes.bool,
    updateInvalid: PropTypes.func,
};

export default LicenseOuterFormComponent;



// WEBPACK FOOTER //
// ./src/components/profile/License/LicenseOuterFormComponent.js